import { Flex, useMantineTheme } from '@mantine/core';
import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import type { Goal as GoalModel, Segment } from '@feathr/blackbox';
import { AlertV2 as Alert, EAlertV2Type } from '@feathr/components';

import ConversionPixelSelect from './ConversionPixelSelect';

import * as styles from './ConversionPixelTriggerGoal.css';

interface IProps {
  goal: GoalModel;
}

function ConversionPixelTriggerGoal({ goal }: Readonly<IProps>): JSX.Element {
  // Goal will be used when this component is integrated with the model.
  void goal;
  const { t } = useTranslation();
  const [selectedPixel, setSelectedPixel] = useState<Segment | undefined>();
  const {
    spacing: { '4': gap },
  } = useMantineTheme();

  function handlePixelChange(segment: Segment | undefined): void {
    if (segment) {
      goal.set({ segment: segment.id });
      setSelectedPixel(segment);
    }
  }

  return (
    <Flex direction={'column'} gap={gap}>
      <Alert
        className={styles.alert}
        description={t(
          'Conversion values will be automatically captured from the pixel when it fires. No manual value assignment is available.',
        )}
        title={t('Important')}
        type={EAlertV2Type.info}
      />
      <ConversionPixelSelect onChange={handlePixelChange} value={selectedPixel?.id} />
    </Flex>
  );
}

export default observer(ConversionPixelTriggerGoal);
